import React from 'react'
import className from 'classnames/bind'

import { Text } from 'app/components/common'
import PlaySoundButton from 'app/components/buttons/play-sound-button/play-sound-button.component'

import stylesModule from 'app/components/sounds/sound-popup/sound-popup-main/sound-popup-main.module.scss'
import SoundPopupVideoButton from 'app/components/buttons/sound-popup-video-button/sound-popup-video-button'
import SoundPopupSongVideoButton from 'app/components/buttons/sound-popup-song-video-button/sound-popup-song-video-button'
import { Sound } from 'app/components/sounds/types/sound'

const cx = className.bind(stylesModule)

type SoundPopupMainProps = {
  sound: Sound
  onVideoClick: () => void
  onSongClick: () => void
}

const SoundPopupMain = ({
  sound,
  onVideoClick,
  onSongClick,
}: SoundPopupMainProps) => (
  <div className={cx('sound-popup-main')}>
    <div className={cx('sound-popup-main__sound-player')}>
      <Text
        type="h2"
        modifiers={sound.effect}
        className={cx('sound-popup-main__title')}
      >
        {sound.soundname}
      </Text>
      <PlaySoundButton sound={sound} />
    </div>
    <div className={cx('sound-popup-main__video-players')}>
      <SoundPopupVideoButton sound={sound} onVideoClick={onVideoClick} />
      <SoundPopupSongVideoButton sound={sound} onSongClick={onSongClick} />
    </div>
  </div>
)

export default SoundPopupMain
